function initDonationForm(block, disableSubmit = false) {
    const form = block.querySelector('form');
    if (!form) {
        return;
    }

    const presetAmountInputs = form.querySelectorAll('input[type=radio]');
    const differentAmountButton = form.querySelector('.donation-form__different-amount-button');
    const differentAmountControl = form.querySelector('.donation-form__different-amount-control');
    const differentAmountInput = form.querySelector('.donation-form__different-amount-control input');

    const toggleDifferentAmount = (state) => {
        differentAmountButton.classList.toggle('is-hidden', state);
        differentAmountControl.classList.toggle('is-hidden', !state);
        differentAmountInput.disabled = !state;
        presetAmountInputs.forEach((input) => input.toggleAttribute('required', !state));

        if (state) {
            differentAmountInput.focus();
        }
    };

    differentAmountButton.addEventListener('click', () => {
        toggleDifferentAmount(true);
        form.reset();
    });

    form.addEventListener('change', (e) => {
        if (e.target.matches('input[type=radio]')) {
            toggleDifferentAmount(false);
        }
    });

    form.addEventListener('submit', function (event) {
        if (disableSubmit) {
            event.preventDefault();
            return;
        }

        const isCustom = !differentAmountInput.disabled;
        const checkedPreset = form.querySelector('input[type=radio]:checked');

        hooks.doAction(
            constants.GTM_INTERACTION,
            {
                event: 'donation_submit',
                donation: {
                    amount: isCustom ? null : Number(checkedPreset.value),
                    amount_type: isCustom ? 'custom' : 'preset',
                },
            },
            form.querySelector('button[type=submit]')
        );
    });
}

function initAllDonationForms() {
    document.querySelectorAll('.donation-form').forEach(initDonationForm);

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=roundabout/donation-form', function ($block) {
            initDonationForm($block[0], true);
        });
    }
}

const { hooks, constants, register } = window.sitchco;
register(initAllDonationForms);
